import { render } from "./AppDesignPropertyPicker.vue?vue&type=template&id=7568c532&scoped=true"
import script from "./AppDesignPropertyPicker.vue?vue&type=script&lang=js"
export * from "./AppDesignPropertyPicker.vue?vue&type=script&lang=js"

import "./AppDesignPropertyPicker.vue?vue&type=style&index=0&id=7568c532&lang=scss&scoped=true"

import exportComponent from "/app/tmp/360pt/V3/v2026.25.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7568c532"]])

export default __exports__